'use strict';

import React, { Component } from 'react';
import Layout from 'Layouts/Front';
import Button from '@material-ui/core/Button';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import getFormStatus from 'Components/Forms/Functions/getFormStatus';
import Breadcrumb from 'Components/Front/Breadcrumb';
import Loader from 'Pure/Loader';
import Link from 'Pure/Link';
import bemit from 'Functions/bemit';
import { getUrlParameter } from 'Shared/utilities';
import { action, URL } from 'Shared/Routes';
const app = window.app;
const qwest = window.qwest;
export default class CancelCompanyBookingPage extends Component {
  state = {
    loading: true,
    status_messages: {},
    breadcrumb: [{
      name: 'home',
      url: URL('HomePage'),
      label: 'Accueil'
    }, {
      name: 'current-page',
      label: 'Annulation de réservation',
      url: URL('CancelCompanyBookingPage')
    }]
  };
  requests = {};
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.verifyToken();
  }
  verifyToken = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post(action('verifyCompanyBookingToken'), {
      token: getUrlParameter('token')
    }).then(function (xhr, response) {
      component.setState({
        loading: false,
        ready: true
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  cancel = () => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.loading) return;
    component.setState({
      loading: true
    });
    qwest.post(action('cancelCompanyBooking'), {
      token: getUrlParameter('token')
    }).then(function (xhr, response) {
      component.setState({
        loading: false,
        ready: false,
        info: 'Réservation annulée avec succès.'
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const loader = state.loading === true ? /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['white', 'bg-red']
    }) : undefined;
    let output = /*#__PURE__*/React.createElement(Layout, props, /*#__PURE__*/React.createElement("div", {
      className: bemit('c-front-page-intro', ['booking-page'])
    }), /*#__PURE__*/React.createElement("div", {
      className: "page-container"
    }, /*#__PURE__*/React.createElement(Breadcrumb, {
      links: state.breadcrumb,
      bemit: ['no-padding'],
      className: "u-margin-bottom-10"
    }), state.ready ? /*#__PURE__*/React.createElement("div", {
      className: "c-message c-message--orange"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-message__content"
    }, "Annuler cette r\xE9servation\xA0? Cette action est d\xE9finitive.")) : undefined, getFormStatus(state), state.ready ? /*#__PURE__*/React.createElement(Button, {
      color: "primary",
      onClick: component.cancel,
      className: "c-flat-btn c-flat-btn--red\r u-margin-top-25"
    }, loader, "Oui, Annuler") : undefined, state.ready ? /*#__PURE__*/React.createElement(Button, {
      color: "primary",
      component: Link,
      href: URL('HomePage'),
      className: "c-flat-btn\r u-margin-top-25"
    }, loader, "Non, Fermer") : undefined));
    return output;
  }
}
